import { render, staticRenderFns } from "./zdy.vue?vue&type=template&id=56a527d4&scoped=true&"
import script from "./zdy.vue?vue&type=script&lang=js&"
export * from "./zdy.vue?vue&type=script&lang=js&"
import style0 from "./zdy.vue?vue&type=style&index=0&id=56a527d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a527d4",
  null
  
)

export default component.exports